import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { notify } from 'react-notify-toast';
import { useHistory } from 'react-router-dom';
import clientAxios from '../../clients/clientAxios';
import CursosList from './CursosList';
import AddCurso from './AddCurso';
import EditCurso from './EditCurso';
import ConfirmDeleteCurso from './ConfirmDeleteCurso';

export default function Cursos() {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [cursos, setCursos] = useState([]);
  const [orderBy, setOrderBy] = useState('-createdAt');
  const [sortBy, setSortBy] = useState('createdAt');
  const [showAddCurso, setShowAddCurso] = useState(false);
  const [showEditCurso, setShowEditCurso] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [selectedCurso, setSelectedCurso] = useState(null);

  const headerConfig = {
    headers: { 'auth-token': localStorage.getItem('JWT') || ' ' },
  };

  useEffect(() => {
    getCursos();
    //eslint-disable-next-line
  }, [orderBy, sortBy]);

  const getCursos = async () => {
    try {
      setIsLoading(true);
      const { data } = await clientAxios.get('/courses', {
        params: { orderBy, sortBy },
        ...headerConfig,
      });
      setCursos(data || []);
      setIsLoading(false);
    } catch (err) {
      notify.show(
        err?.response?.data?.message || 'Error al cargar los cursos',
        'error'
      );
      setIsLoading(false);
    }
  };

  const handleAddCurso = () => {
    setSelectedCurso(null);
    setShowAddCurso(true);
  };

  const handleEditCurso = (curso) => {
    setSelectedCurso(curso);
    setShowEditCurso(true);
  };

  const handleDeleteCurso = (curso) => {
    setSelectedCurso(curso);
    setShowConfirmDelete(true);
  };

  const handleConfirmDelete = async () => {
    try {
      if (!selectedCurso?._id) {
        notify.show('No se puede eliminar el curso', 'error');
        return;
      }

      await clientAxios.delete(`/courses/${selectedCurso._id}`, headerConfig);
      notify.show('Curso eliminado correctamente', 'success');
      setShowConfirmDelete(false);
      setSelectedCurso(null);
      getCursos();
    } catch (err) {
      notify.show(
        err?.response?.data?.message || 'Error al eliminar el curso',
        'error'
      );
    }
  };

  const handleCursoSaved = () => {
    getCursos();
    setShowAddCurso(false);
    setShowEditCurso(false);
    setSelectedCurso(null);
  };

  return (
    <Container className='mt-5'>
      <Row className='mb-4'>
        <Col>
          <h1>Gestión de Cursos</h1>
        </Col>
        <Col className='text-right'>
          <Button
            variant='success'
            onClick={handleAddCurso}
            className='mb-3'
          >
            <i className='mr-2 fas fa-plus' />
            Crear Curso
          </Button>
        </Col>
      </Row>

      <CursosList
        cursos={cursos}
        isLoading={isLoading}
        onEdit={handleEditCurso}
        onDelete={handleDeleteCurso}
      />

      <AddCurso
        show={showAddCurso}
        onHide={() => setShowAddCurso(false)}
        onSave={handleCursoSaved}
      />

      {selectedCurso && (
        <EditCurso
          show={showEditCurso}
          onHide={() => setShowEditCurso(false)}
          curso={selectedCurso}
          onSave={handleCursoSaved}
        />
      )}

      <ConfirmDeleteCurso
        show={showConfirmDelete}
        onHide={() => setShowConfirmDelete(false)}
        onConfirm={handleConfirmDelete}
        cursoName={selectedCurso?.name}
      />
    </Container>
  );
}
